import { ChainId, FactoryVersion } from '@nominex/nomiswap-sdk'
import { tokens } from 'config/tokens'
import { serializeFarm } from './helpers'
import { SerializedFarmConfig } from './types'

// Farm pid should start from chain id

const farms: SerializedFarmConfig[] = [
  {
    pid: 1201,
    token: tokens[ChainId.ETHEREUM].dai,
    quoteToken: tokens[ChainId.ETHEREUM].usdt,
    earningToken: tokens[ChainId.ETHEREUM].nmx,
    lpAddress: '0x9Daeb0A1849D57f6BEBe0e5969644950f0689936',
    stakingServiceAddress: '0x1979Cef6E03E13E64715B2c6847d8970675Bd582',
    finished: true,
    version: FactoryVersion.V2,
  },
  {
    pid: 1202,
    token: tokens[ChainId.ETHEREUM].usdc,
    quoteToken: tokens[ChainId.ETHEREUM].usdt,
    earningToken: tokens[ChainId.ETHEREUM].nmx,
    lpAddress: '0xe219a14e355c1Cb3f43594655A63488DA154E8Eb',
    stakingServiceAddress: '0x9947d076fcF5B55359c6a4Ebe4acb7e2FB9212f8',
    finished: true,
    version: FactoryVersion.V2,
  },
].map(serializeFarm)

export default farms
